import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Flash = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
      const targetDate = new Date("2025-08-15T00:00:00");
      
      const updateTimer = () => {
        const now = new Date();
        const diff = targetDate - now;
  
        if (diff > 0) {
          setTimeLeft({
            days: Math.floor(diff / (1000 * 60 * 60 * 24)),
            hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((diff / 1000 / 60) % 60),
            seconds: Math.floor((diff / 1000) % 60)
          });
        } else {
          setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        }
      };
  
      updateTimer();
      const timer = setInterval(updateTimer, 1000);
      return () => clearInterval(timer);
    }, []);

  if (!isVisible) return null;

  const hasCountdownEnded = timeLeft.days === 0 && timeLeft.hours === 0 && 
                          timeLeft.minutes === 0 && timeLeft.seconds === 0;

  return (
    <div className="floating-countdown-banner">
      <div className="countdown-container">
        {/* <button 
          className="close-button" 
          onClick={() => setIsVisible(false)}
          aria-label="Close banner"
        >
          ×
        </button> */}
        <div className="countdown-content">
          <div className="price-display">
            <span className="current-price">RZTO: ${hasCountdownEnded ? '0.004' : '0.003'}</span>
            {!hasCountdownEnded && (
              <span className="new-price">→ $0.004 in:</span>
            )}
          </div>
          
          {!hasCountdownEnded && (
            <div className="countdown-timer">
              <div className="time-block">
                <span>{timeLeft.days.toString().padStart(2, '0')}</span>
                <small>DAYS</small>
              </div>
              <div className="time-block">
                <span>{timeLeft.hours.toString().padStart(2, '0')}</span>
                <small>HOURS</small>
              </div>
              <div className="time-block">
                <span>{timeLeft.minutes.toString().padStart(2, '0')}</span>
                <small>MINUTES</small>
              </div>
              <div className="time-block">
                <span>{timeLeft.seconds.toString().padStart(2, '0')}</span>
                <small>SECONDS</small>
              </div>
            </div>
          )}

        </div>
      </div>

      <style jsx>{`    
        .floating-countdown-banner {
          position: relative;
          width: 100%;
          background: linear-gradient(90deg, #1a1a2e 0%, #16213e 100%);
          color: white;
          padding: 12px 0;
          font-family: 'Rajdhani', 'Arial', sans-serif;
          box-shadow: 0 4px 15px rgba(0,0,0,0.5);
          z-index: 1000;
          border-bottom: 2px solid #00f5d4;
        }

        .countdown-container {
          display: flex;
          justify-content: center;
          align-items: center;
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
          position: relative;
        }

        .countdown-content {
          display: flex;
          align-items: center;
          gap: 20px;
          width: 100%;
          justify-content: center;
          flex-wrap: wrap;
        }

        .price-display {
          display: flex;
          align-items: center;
          gap: 10px;
          font-weight: bold;
          font-size: 18px;
          white-space: nowrap;
        }

        .current-price {
          color: #00f5d4;
        }

        .new-price {
          font-size: 16px;
          opacity: 0.9;
        }

        .countdown-timer {
          display: flex;
          justify-content: center;
          gap: 15px;
        }

        .time-block {
          background: rgba(0, 0, 0, 0.3);
          padding: 8px 12px;
          border-radius: 8px;
          min-width: 60px;
          text-align: center;
        }

        .time-block span {
          font-size: 1.5rem;
          font-weight: bold;
          display: block;
        }

        .time-block small {
          font-size: 0.8rem;
          color: #a8a8a8;
          text-transform: uppercase;
        }

        .buy-now-button {
          background: linear-gradient(90deg, #00f5d4 0%, #00b4d8 100%);
          color: #0f3460;
          border: none;
          padding: 8px 20px;
          border-radius: 5px;
          font-weight: bold;
          font-size: 16px;
          cursor: pointer;
          text-decoration: none;
          transition: all 0.3s;
          white-space: nowrap;
        }

        .buy-now-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(0,245,212,0.4);
        }

        .close-button {
          position: absolute;
          right: 20px;
          background: none;
          border: none;
          color: white;
          cursor: pointer;
          opacity: 0.7;
          transition: opacity 0.2s;
          padding: 5px;
          font-size: 1.5rem;
        }

        .close-button:hover {
          opacity: 1;
        }

        @media (max-width: 768px) {
          .countdown-container {
            padding: 10px 35px 10px 20px;
          }

          .countdown-content {
            flex-direction: column;
            gap: 10px;
            align-items: center;
          }

          .price-display {
            font-size: 16px;
            flex-direction: column;
            gap: 4px;
          }

          .countdown-timer {
            gap: 8px;
          }

          .time-block {
            min-width: 50px;
            padding: 6px 8px;
          }

          .time-block span {
            font-size: 1.2rem;
          }

          .time-block small {
            font-size: 0.7rem;
          }

          .buy-now-button {
            margin-top: 5px;
            padding: 6px 15px;
            font-size: 14px;
          }
        }

        @media (max-width: 480px) {
          .price-display {
            font-size: 14px;
          }

          .time-block {
            min-width: 40px;
          }

          .time-block span {
            font-size: 1rem;
          }
        }
      `}</style>
    </div>
  );
};

export default Flash;